import axiosRequest from '../constants/axios-request'
import { Email } from '../types/email'

export const sendEmail = (email: Email): Promise<number> =>
  axiosRequest
    .post('/contact-us', email)
    .then((result) => result.status)
    .catch((error) => error.response.status)
